import API from './client'
import type { UpdateStatusPayload, UpdateDeliveryPayload, CreateDeliveryPayload, Delivery } from '../types'

export interface DeliveryFilters {
  status?: string
  page?: number
  limit?: number
  search?: string
  expediteur?: string
  livreur?: string
  dateFrom?: string
  dateTo?: string
}

export interface DeliveriesListResponse {
  data: Delivery[]
  total: number
  page: number
  totalPages: number
}

export const deliveriesAPI = {
  getAll: async (params?: DeliveryFilters): Promise<DeliveriesListResponse> => {
    const res = await API.get('/deliveries', { params })
    return res.data
  },

  getById: async (id: string): Promise<Delivery> => {
    const res = await API.get(`/deliveries/${id}`)
    return res.data.delivery
  },

  create: (data: CreateDeliveryPayload | Record<string, unknown>) =>
    API.post('/deliveries', data),

  updateStatus: (id: string, payload: UpdateStatusPayload) =>
    API.patch(`/deliveries/${id}/status`, payload),

  update: (id: string, data: UpdateDeliveryPayload | Record<string, unknown>) =>
    API.patch(`/deliveries/${id}`, data),

  validate: (id: string) =>
    API.patch(`/deliveries/${id}/validate`),

  assign: (id: string, livreurId: string) =>
    API.patch(`/deliveries/${id}/assign`, { livreurId }),

  getContact: (id: string) =>
    API.get(`/deliveries/${id}/contact`),

  sendMessage: (id: string, channel: 'sms' | 'whatsapp', message?: string) =>
    API.post(`/deliveries/${id}/message`, { channel, message }),

  getPriceEstimate: (params: { fromLat: number; fromLng: number; toLat: number; toLng: number }) =>
    API.get('/deliveries/price-estimate', { params }),

  addComment: (id: string, note: string) =>
    API.post(`/deliveries/${id}/comment`, { note }),

  addReclamation: (id: string, payload: { type: string; description: string }) =>
    API.post(`/deliveries/${id}/reclamation`, payload),

  signalerEchec: async (id: string, payload: { reason: string; note?: string; photos?: string[] }) => {
    const res = await API.post(`/deliveries/${id}/echec`, payload)
    return res.data
  },

  confirmerRetour: async (id: string) => {
    const res = await API.post(`/deliveries/${id}/confirmer-retour`)
    return res.data
  },

  reprogrammerColis: async (id: string, rescheduledFor: string) => {
    const res = await API.post(`/deliveries/${id}/reprogrammer`, { rescheduledFor })
    return res.data
  },

  demanderRetour: async (id: string) => {
    const res = await API.post(`/deliveries/${id}/retour`)
    return res.data
  },

  abandonnerColis: async (id: string, motif: string) => {
    const res = await API.post(`/deliveries/${id}/abandon`, { motif })
    return res.data
  },

  getEchecs: async (params?: { statut?: string; page?: number }) => {
    const res = await API.get('/deliveries/echecs', { params })
    return res.data
  },
}
